(function init() {
  // The "Seed from a letter" box at the top of the Hub debug forms [HM-11245]. The form owns the
  // seed state (see createLetterSeed) and does the loading; this only renders it.
  angular.module('app').component('hubLetterSeedBox', {
    templateUrl: require('./hubLetterSeedBox.component.html'),
    bindings: {
      seed: '<',
      showType: '<',
      hasEdits: '<',
      onLoad: '&',
      onReset: '&',
    },
    controller() {
      const $ctrl = this;

      // Enter loads the letter rather than submitting the form underneath.
      $ctrl.onKeydown = (event) => {
        if (event.keyCode !== 13) return;
        event.preventDefault();
        $ctrl.onLoad();
      };
    },
  });
})();
